(() => {
  const closeMenus = (except) => document.querySelectorAll('.fs-nav-disclosure[open]').forEach(menu => { if (menu !== except) menu.open = false; });
  document.addEventListener('toggle', event => { if (event.target.matches('.fs-nav-disclosure') && event.target.open) closeMenus(event.target); }, true);
  document.addEventListener('click', event => { if (!event.target.closest('.fs-nav')) closeMenus(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const menu = document.activeElement?.closest('.fs-nav-disclosure[open]'); closeMenus(); menu?.querySelector('summary')?.focus(); } });
})();
